import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text } from '@Sage/hoi-poi-ui';

const OneRow = memo(({ label, className }) => (
    <Text type="body" isTruncated useTooltip className={classnames(className)}>
        {label}
    </Text>
));

OneRow.displayName = 'OneRow';

OneRow.propTypes = {
    label: PropTypes.node,
    className: PropTypes.string,
};

export default OneRow;
